(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  function initLivdonHeaderStickyGroup() {
    const announcement = document.querySelector('.announcement-bar-section.shopify-section-group-header-group');
    const headerSection = document.querySelector('.section-header.shopify-section-group-header-group');

    if (!headerSection || document.querySelector('.livdon-header-sticky-group')) return;

    const group = document.createElement('div');
    group.className = 'livdon-header-sticky-group shopify-section-header-sticky';

    const parent = announcement?.parentNode || headerSection.parentNode;
    const insertBefore = announcement || headerSection;
    parent.insertBefore(group, insertBefore);

    if (announcement) group.appendChild(announcement);
    group.appendChild(headerSection);

    document.dispatchEvent(new CustomEvent('livdon:header-group-ready'));
  }

  initLivdonHeaderStickyGroup();
  document.addEventListener('shopify:section:load', initLivdonHeaderStickyGroup);

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      initLivdonHeaderStickyGroup();
      this.headerGroup = document.querySelector('.livdon-header-sticky-group');
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky && this.headerGroup) {
        this.headerGroup.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerRow = this.querySelector('.header');
      const searchBand = this.querySelector('.page-search');
      const announcementBar = document.querySelector('.announcement-bar-section');
      const headerRowHeight = headerRow?.offsetHeight || this.header.offsetHeight;
      const announcementHeight = announcementBar?.offsetHeight || 0;
      let searchBandHeight = 0;

      if (searchBand) {
        const collapseProgress = parseFloat(
          getComputedStyle(document.body).getPropertyValue('--search-collapse-progress') || '0'
        );
        const expandedBandHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--page-search-expanded-band-height') || '0'
        );
        const bandBaseHeight = expandedBandHeight || searchBand.offsetHeight;
        searchBandHeight = bandBaseHeight * (1 - collapseProgress);
      }

      const groupHeight = announcementHeight + headerRowHeight + searchBandHeight;

      document.documentElement.style.setProperty('--header-height', `${headerRowHeight}px`);
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--header-search-band-height', `${searchBandHeight}px`);
      document.documentElement.style.setProperty('--header-group-offset', `${groupHeight}px`);
      document.documentElement.style.setProperty('--header-group-visible-height', `${groupHeight}px`);
      document.body.style.setProperty('--page-search-offset', `${groupHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerGroup || this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const stickyTarget = this.headerGroup || this.header;
      stickyTarget.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const stickyTarget = this.headerGroup || this.header;
      stickyTarget.classList.add('shopify-section-header-sticky', 'animate');
      stickyTarget.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const stickyTarget = this.headerGroup || this.header;
      stickyTarget.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
